var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryThamMy = function SvgCategoryThamMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.917,
    cy: 32.083,
    r: 16.917,
    fill: "#CBE7FF",
    transform: "rotate(-90 23.917 32.083)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 10.5,
    r: 3.5,
    fill: "#CBE7FF",
    transform: "rotate(-90 45.5 10.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C4D84",
    strokeWidth: 1.3,
    d: "M15.11 24.306c.943 6.596 6.616 11.666 13.473 11.666s12.53-5.07 13.473-11.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C4D84",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M34.903 13.733a10.65 10.65 0 0 0-6.32-2.066c-5.906 0-10.694 4.788-10.694 10.694a10.66 10.66 0 0 0 3.095 7.525m15.74-14.461a10.65 10.65 0 0 1 2.554 6.936c0 5.906-4.788 10.695-10.695 10.695-1.428 0-2.791-.28-4.037-.788"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C4D84",
    d: "M23.15 31.15a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C4D84",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M31.014 39.412h-8.208a2 2 0 0 0-2 2v1.39a.5.5 0 0 0 .5.5H35.86a.5.5 0 0 0 .5-.5v-1.39a2 2 0 0 0-2-2h-1.159"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C4D84",
    strokeWidth: 1.3,
    d: "M39.278 24.306h1.944a1.944 1.944 0 0 0 0-3.889h-1.944M17.889 24.306h-1.945a1.944 1.944 0 0 1 0-3.889h1.945M28.584 35.972v3.403"
  })));
};
export default SvgCategoryThamMy;